/**
 * Configuration utilities for the FairShare SDK
 */

/**
 * Default API endpoint
 */
export const DEFAULT_API_ENDPOINT = "https://api.fluid.app";

/**
 * Get the API endpoint
 * @returns The API endpoint URL
 */
export const getApiEndpoint = (): string => {
  return DEFAULT_API_ENDPOINT;
};

/**
 * Default configuration values
 */
export const DEFAULT_CONFIG = {
  API_ENDPOINT: DEFAULT_API_ENDPOINT,
  RETRY_ATTEMPTS: 3,
  ATTRIBUTION_WINDOW: 30, // days
  ATTRIBUTION_MODEL: "last-touch" as const,
  SHARE_TOKEN_PARAM: "share_token",
};
